var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14645 5.45586C4.95118 5.65112 4.95118 5.9677 5.14645 6.16296C5.34171 6.35823 5.65829 6.35823 5.85355 6.16296L7.30922 4.7073V12.5C7.30922 12.7761 7.53307 13 7.80922 13C8.08536 13 8.30922 12.7761 8.30922 12.5V4.70691L9.76527 6.16296C9.96053 6.35823 10.2771 6.35823 10.4724 6.16296C10.6676 5.9677 10.6676 5.65112 10.4724 5.45586L8.16296 3.14645C8.06099 3.04447 7.92593 2.99575 7.79234 3.00029C7.6569 3.00478 7.53511 3.06314 7.44769 3.15462L5.14645 5.45586Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpIcon);
export default __webpack_public_path__ + "static/media/sort-up-icon.c1ea50ab120b08eab1deed7b2ffe9f8d.svg";
export { ForwardRef as ReactComponent };